import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Typography } from '@mui/material';

import { useT } from '@/hooks';

interface DepositOptionsSectionProps {
  fetchingPayment: boolean;
  currentPaymentName?: string;
  currentPaymentIcon?: string;
  onShowPaymentList: () => void;
}

export const DepositOptionsSection = ({
  fetchingPayment,
  currentPaymentName,
  currentPaymentIcon,
  onShowPaymentList,
}: DepositOptionsSectionProps) => {
  const { t } = useT();
  return (
    <Box className="mt-2 flex flex-col gap-2 px-1">
      <Typography className="text-sm font-medium text-[var(--text-muted)]">
        {t('depositModal.payUsing', { defaultValue: 'Pay using' })}
      </Typography>
      <button
        onClick={onShowPaymentList}
        className="flex items-center justify-between rounded-[20px] border border-[var(--border-color)] bg-[var(--bg-secondary)] p-5 text-[var(--text-primary)] transition-all hover:border-[var(--text-primary)] dark:bg-[#F8F9FB10]"
      >
        <Box className="flex items-center gap-4">
          <Box className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-xl bg-[#627EEA15]">
            {currentPaymentIcon ? (
              <Box component="img" src={currentPaymentIcon} className="h-6 w-6 object-contain" />
            ) : (
              <Typography className="text-lg">💳</Typography>
            )}
          </Box>
          <Typography className="text-base font-bold">
            {fetchingPayment
              ? t('common.loading', { defaultValue: 'Loading...' })
              : currentPaymentName ||
                t('depositModal.selectPaymentMethod', { defaultValue: 'Select payment method' })}
          </Typography>
        </Box>
        <KeyboardArrowDownIcon sx={{ fontSize: 24, color: 'var(--text-muted)' }} />
      </button>
    </Box>
  );
};
